import { Show, createEffect, createMemo, createSignal, on } from "solid-js";

import { GetUnread } from "@/api/clientApi/notice.ts";
import { GetUserPayChannelV2 } from "@/api/clientApi/wallet.ts";
import { Button } from "@/components/Base/Button/Button.tsx";
import { DialogType } from "@/components/Dialogs/types.ts";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import Icon from "@/components/Icon";
import { getImageAltByLang } from "@/constants/seo-constants.ts";
import { useCheckDomReady } from "@/hooks/useCheckDomReady.ts";
import { useGlobalSearch } from "@/hooks/useGlobalSearch.ts";
import {
  notificationStore,
  setNotificationStore,
} from "@/hooks/useNotification.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { getLocale, useI18n } from "@/i18n/index";
import { formatToBindPoint } from "@/lib/pointUtils.ts";
import { getImgurl } from "@/lib/resFolder.ts";
import { sdkManager } from "@/lib/sdk/sdkManager.ts";
import { cn } from "@/lib/utils.ts";
import { getWebsiteConfigV2 } from "@/stores/configStore.ts";
import { getVipItem } from "@/stores/depositStore.tsx";
import { sidebarStore } from "@/stores/sidebar.ts";
import { sidebarContainerStore } from "@/stores/sidebarContainerStore.ts";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { userStore } from "@/stores/userStore.ts";
import { useLocation } from "@solidjs/router";

import BonusDropdownMenu from "./BonusDropdownMenu.tsx";
import UserDropdownMenu from "./UserDropdownMenu.tsx";
import WalletDropdownMenu from "./WalletDropdownMenu.tsx";

export default function PCHeader(props: { isLandingPage?: boolean }) {
  const { t } = useI18n();
  const { showDialog } = useDialog();
  const location = useLocation();
  const { push, toDeposit, preCheckEnterGame } = useRouter();
  const count = createMemo(() => notificationStore.count);

  createEffect(
    on(
      () => userStore.isLogin,
      (isLogin) => {
        if (isLogin) {
          console.log("get unread");
          GetUnread({ msg_type: 0 }).then((res) => {
            const count = (res?.unread?.[1] || 0) + (res?.unread?.[2] || 0);
            setNotificationStore("count", count);
          });
        }
      },
    ),
  );

  const isDomReady = useCheckDomReady();

  const { openGlobalSearchModal } = useGlobalSearch();

  const [activeTab, setActiveTab] = createSignal<number | null>(null);
  // 活动和道具间不比较
  const [displayAmount, setDisplayAmount] = createSignal<string | null>(null);

  const isLogin = createMemo(() => userStore.isLogin);

  createEffect(
    on(
      createMemo(() => location.pathname),
      () => {
        if (location.pathname.includes("casino")) {
          setActiveTab(0);
        } else if (location.pathname.includes("sports")) {
          setActiveTab(1);
        } else {
          setActiveTab(null);
        }
      },
    ),
  );

  // createEffect(() => {
  //   getDepositReward();
  // });
  createEffect(
    on(
      () => userStore.isLogin,
      () => {
        getDepositReward();
      },
      // {
      //   defer: true,
      // },
    ),
  );

  const getDepositReward = async () => {
    const res = await GetUserPayChannelV2({
      point_type: sysConfigStore.point_type,
    });
    if (res) {
      if (res?.discount?.activity_list) {
        res?.discount?.activity_list.map((item) => {
          if ([65].includes(item.atype)) {
            const vip_level = userStore.userInfo?.UserVip?.vip_level;
            const vipItem = getVipItem(
              item?.activity_config?.vip_cfg,
              vip_level,
            );
            // 匹配等级
            if (!vipItem) {
              item.result = "0";
              return item;
            }
            const activityItem =
              vipItem?.reward_cfg?.[vipItem?.reward_cfg.length - 1];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else if ([13].includes(item.atype)) {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          } else {
            const activityItem =
              item?.activity_config?.list?.[
                item?.activity_config?.list.length - 1
              ];
            if (activityItem?.reward?.reward_point_mode === 1) {
              setDisplayAmount(
                formatToBindPoint({
                  value: activityItem?.reward?.point,
                  pointType: sysConfigStore.point_type,
                  showSymbol: true,
                  bDeleteZeroPoint: true,
                }),
              );
            } else {
              setDisplayAmount(`${activityItem?.reward?.pay_pro / 100}%`);
            }
          }
        });
      }
      if (res?.discount?.promoitem_list) {
        const promoitem_list = res.discount?.promoitem_list;
        const resultProp = promoitem_list?.[0];
        const cfg_data = JSON.parse(resultProp.cfg_data);
        const config = JSON.parse(cfg_data?.config);
        // const item_lang = JSON.parse(cfg_data?.item_lang);
        const detail = config?.reward_list[config?.reward_list.length - 1];
        if (config?.reward_type === 0) {
          setDisplayAmount(
            formatToBindPoint({
              value: detail?.value,
              pointType: sysConfigStore.point_type,
              showSymbol: true,
              bDeleteZeroPoint: true,
            }),
          );
        } else {
          setDisplayAmount(`${detail?.value / 10000}%`);
        }
      }
    }
  };

  // 处理游戏类型标签切换
  async function handleTabChange(tab: number) {
    const defaultSportGameId = sysConfigStore.sport_config.sport_game_id;

    if (tab == 1) {
      if (userStore.isLogin) {
        const pass = await preCheckEnterGame({
          gid: `${defaultSportGameId}`,
          // itemId: `${props?.itemId}`,
          // bindPointType: bindPointType,
        });
        if (!pass) {
          return;
        }
      }

      push(`/sports/${defaultSportGameId}`);
    } else {
      push("/casino");
    }
    setActiveTab(tab);
  }

  return (
    <header
      // --notification-width
      class={`bg-general-up-di z-[1000] flex ${sidebarContainerStore.state.isExpanded ? "w-[calc(100%-400px)]" : ""}`}
    >
      <Show when={!props?.isLandingPage} fallback={<></>}>
        <div
          class={`flex h-full items-center justify-between px-[12px] ${sidebarStore.state.isExpanded ? "border-menu-sk w-[240px] justify-start border-r-[1px]" : "w-[72px] justify-center"}`}
        >
          <div
            onClick={sidebarStore.toggleSidebar}
            class="flex w-[20px] cursor-pointer items-center justify-center"
          >
            <Show when={sidebarStore.state.isExpanded} fallback={<></>}>
              <Icon
                name="general/menu_open"
                class="text-menu-darkzi h-[20px] w-[20px]"
              />
            </Show>
            <Show when={!sidebarStore.state.isExpanded} fallback={<></>}>
              <Icon
                name="general/menu_close"
                class="text-menu-darkzi h-[20px] w-[20px] rotate-[180deg]"
              />
            </Show>
          </div>

          <Show when={sidebarStore.state.isExpanded} fallback={<></>}>
            <div class="bg-menu-bg1 ml-[8px] flex h-[36px] w-[188px] items-center justify-center gap-[4px] rounded-sm p-[2px]">
              <div
                class={`group flex h-[32px] flex-1 cursor-pointer items-center justify-center gap-1 rounded-sm py-[6px] ${activeTab() === 0 ? "from-general-main to-general-assist bg-gradient-to-r" : "hover:text-general-light"}`}
                onClick={() => handleTabChange(0)}
              >
                <Icon
                  name="general/casino_big"
                  class={`h-[18px] w-[18px] ${activeTab() === 0 ? "text-general-butzi" : "text-menu-darkzi group-hover:text-general-light"}`}
                  wrapperClass="w-[20px] h-[20px]"
                />

                <span
                  class="group mt-[1px] text-[13px] leading-[17px]"
                  classList={{
                    "text-general-butzi font-[700]": activeTab() === 0,
                    "text-menu-darkzi group-hover:text-general-light font-[500]":
                      activeTab() !== 0,
                  }}
                >
                  {t("home.casino")}
                </span>
              </div>

              <div
                class={`group flex h-[32px] flex-1 cursor-pointer items-center justify-center gap-1 rounded-sm ${activeTab() === 1 ? "from-general-main to-general-assist bg-gradient-to-r" : ""}`}
                onClick={() => handleTabChange(1)}
              >
                <Icon
                  name="general/sports_big"
                  class={`h-[18px] w-[18px] rotate-[180deg] ${activeTab() === 1 ? "text-general-butzi" : "text-menu-darkzi group-hover:text-general-light"}`}
                  wrapperClass="w-[20px] h-[20px]"
                />

                <span
                  class="group mt-[1px] text-[13px] leading-[17px]"
                  classList={{
                    "text-general-butzi font-[700]  ": activeTab() === 1,
                    "text-menu-darkzi group-hover:text-general-light font-[500]":
                      activeTab() !== 1,
                  }}
                >
                  {t("home.sports")}
                </span>
              </div>
            </div>
          </Show>
        </div>
      </Show>
      <div class="mx-auto max-w-[1200px] flex-1">
        <div class="header-content">
          {/* <Link href="/" class="clickable flex"> */}
          <img
            src={`/${__APP_NAME__}/images/logo/logo.png`}
            alt={getImageAltByLang("logo")}
            class="clickable mb-[auto] mt-[auto] h-[34px] w-auto"
            onClick={() => {
              sdkManager.tdReportEvent("afun_homepage_click", {
                from_page: window.location.pathname,
              });
              push("/");
            }}
          />
          {/* </Link> */}

          {/* 搜索框 */}
          <Show when={isDomReady() && !props?.isLandingPage} fallback={<></>}>
            <div
              class="clickable flex h-[43px] min-w-[80px] max-w-[360px] flex-1 items-center rounded-[22px] bg-[#111412] px-[12px]"
              onclick={openGlobalSearchModal}
            >
              <Icon
                name="search"
                class="text-up-icon1 h-[16.66px] w-[15.66px]"
                wrapperClass="w-[22px] h-[22px]"
              />
            </div>
          </Show>

          <div
            class={`flex items-center gap-[12px] ${sidebarContainerStore.state.isExpanded ? "pr-6" : ""}`}
          >
            <Show when={isLogin() && isDomReady()} fallback={<></>}>
              <Show when={!props?.isLandingPage} fallback={<></>}>
                <div class="bg-up-icondi border-up-stroke flex h-[42px] w-auto items-center rounded-sm border p-[4px]">
                  <WalletDropdownMenu />
                  <div
                    class="bg-linear-90 from-up-mainbut-l to-up-mainbut-r text-up-butzi clickable relative flex h-[34px] w-auto min-w-[96px] items-center gap-1 rounded-[6px] px-[10px] text-[14px] font-bold leading-[17px]"
                    onclick={() => toDeposit()}
                  >
                    <Icon
                      name="general/bottom_withdrawal"
                      class="text-up-butzi h-[18px] w-[18px]"
                    />
                    <span class="text-up-butzi text-[14px] font-[700] leading-[17px]">
                      {t("affiliate.deposit")}
                    </span>
                    <Show when={displayAmount()} fallback={<></>}>
                      <div class="absolute top-[34px] ml-[-66px]">
                        <img
                          src={getImgurl(
                            `top-1.png`,
                            "common/home/deposit-act",
                          )}
                          class={cn("h-[42px] w-[141px] shrink-0")}
                        />
                        <span class="text-general-light absolute ml-[36px] mt-[-23px] w-[95px] text-center text-[12px] font-bold">
                          {t("deposit.max_bonus", {
                            val: displayAmount() || "",
                          })}
                        </span>
                      </div>
                    </Show>
                  </div>
                </div>
              </Show>

              {/* 奖金中心 */}
              <div class={`${isLogin() ? "mr-[6px]" : ""}`}>
                <BonusDropdownMenu />
              </div>
            </Show>
            {/* 用户中心 */}
            <Show when={isLogin()} fallback={<></>}>
              <UserDropdownMenu />
            </Show>

            <Show when={!isLogin() && isDomReady()} fallback={<></>}>
              {/* <Icon
                name="general/search"
                class="text-up-icon1 group-hover:text-general-light h-[18px] w-[18px]"
                wrapperClass="bg-up-icondi clickable h-[40px] w-[40px] group rounded-md "
                onClick={openGlobalSearchModal}
              /> */}
              <Show when={!props?.isLandingPage} fallback={<></>}>
                <BonusDropdownMenu />
              </Show>
              <Button
                class="h-[40px] w-fit rounded-[8px] px-[18.3px] text-[15px] font-[800] leading-[24px]"
                variant="default"
                size="default"
                onClick={() => {
                  sdkManager.tdReportEvent("signin_button_click", {
                    from_page: window.location.pathname,
                  });
                  push("login");
                }}
              >
                {t("auth.sign_in")}
              </Button>
              <Button
                class="text-general-main bg-general-main10 relative h-[40px] w-fit rounded-[8px] px-[19.5px] text-[15px] font-[800] leading-[24px]"
                size="default"
                onClick={() => {
                  sdkManager.tdReportEvent("signup_button_click", {
                    from_page: window.location.pathname,
                  });
                  push("register");
                }}
              >
                {t("auth.sign_up")}
                <Show
                  when={getWebsiteConfigV2()?.registerRewardSwitch}
                  fallback={<></>}
                >
                  <div class="absolute top-[40px] ml-[-62px]">
                    <img
                      src={getImgurl(
                        `top-${getLocale()}.png`,
                        "common/home/deposit-act/locale",
                      )}
                      class={cn("w-[184px] shrink-0")}
                    />
                  </div>
                </Show>
              </Button>
            </Show>
            <Show when={!props?.isLandingPage} fallback={<></>}>
              <Show when={isLogin() && isDomReady()} fallback={<></>}>
                <div
                  class="bg-up-icondi clickable group relative flex h-[40px] w-[40px] items-center justify-center rounded-[8px]"
                  onClick={sidebarContainerStore.toggleSidebar}
                >
                  <Icon
                    // prettier-ignore
                    name="general/notify3"
                    class={`group-hover:text-general-light ${sidebarContainerStore.state.isExpanded ? "text-general-light" : "text-up-icon1"} clickable h-[18px w-[18px]`}
                  />

                  <Show when={count() > 0} fallback={<></>}>
                    <div class="bg-general-main absolute right-[6px] top-[6px] h-[6px] w-[6px] rounded-full" />
                  </Show>
                </div>
              </Show>

              <Icon
                name="general/globe"
                class="text-up-icon1 group-hover:text-general-light h-[18px] w-[18px]"
                wrapperClass="bg-up-icondi clickable h-[40px] w-[40px] group  rounded-[8px]"
                onClick={() => showDialog({ type: DialogType.SwitchLanguage })}
              />
            </Show>
          </div>
        </div>
      </div>
    </header>
  );
}
